import { Component } from '@theme/component';
class ZaikoCompare extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.controller?.abort();
    this.controller = new AbortController();
    const selects = [...this.querySelectorAll('select')];
    if (selects.length !== 2) return;
    if (!this.initialized) {
      selects[1].selectedIndex = Math.min(1, selects[1].options.length - 1);
      this.initialized = true;
    }
    const update = (announce = false) => {
      for (const select of selects) {
        const template = this.querySelector(`template[data-product="${select.value}"]`);
        const result = this.querySelector(`[data-result="${select.dataset.slot}"]`);
        if (template instanceof HTMLTemplateElement && result) result.replaceChildren(template.content.cloneNode(true));
      }
      const status = this.querySelector('[role="status"]');
      if (status) status.textContent = selects[0].value === selects[1].value ? this.dataset.same : announce ? this.dataset.updated : '';
    };
    for (const select of selects) select.addEventListener('change', () => update(true), { signal: this.controller.signal });
    update();
    this.querySelector('.zc-columns')?.removeAttribute('hidden');
    if (location.hash === '#za-compare') this.closest('details')?.setAttribute('open', '');
  }
  disconnectedCallback() {
    this.controller?.abort();
    super.disconnectedCallback();
  }
}
if (!customElements.get('zaiko-compare')) customElements.define('zaiko-compare', ZaikoCompare);
